import React from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import Pagination from '../../component/Pagination';
import InvoiceStatus from '../../component/InvoiceStatus';
import AlertLabel from '../../component/AlertLabel';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, RenderSearchForm } from '../../component/formInput';
import moment from 'moment';
import InvoiceStatusSelect from '../../component/InvoiceStatusSelect';
import { StringUtils } from '../../utils/javascriptUtils';
import PaymentTypeSelect from '../../component/PaymentTypeSelect';
import { connect } from 'react-redux';

var numeral = require('numeral');
var _ = require('lodash');
const start_date_of_current_month = moment().startOf('month');
const end_date_of_current_month = moment().endOf('month');
const start_date_of_previous_month = moment().subtract(1,'months').startOf('month');
const end_date_of_previous_month = moment().subtract(1,'months').endOf('month');


function InvoiceDatePicker(from_date, to_date, onDateChange, clearDataFilter) {
  return ( 
    <div style={{float: "right"}}>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height:20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="from_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          defaultValue={from_date}
          onChangeAction={(value)=>onDateChange(value, to_date)}
          component={RenderDatePicker}
          />
      </div>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height: 20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="to_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          defaultValue={to_date}
          onChangeAction={(value)=>onDateChange(from_date, value)}
          component={RenderDatePicker}/>
      </div>
    </div>
  )
}

function InvoiceRows(userProfile, role_path, invoice_data) {
    const inner_invoice_rows = _.map(invoice_data,(invoice, key) => {
      return (
        <tr key={key}>
          <td>
            <Link to={role_path + "/invoice/detail/"+invoice.id}>{invoice.code}</Link>
            <br/>
            {invoice.agency_invoice && <Link to={role_path + "/invoice/agency/detail/"+invoice.agency_invoice.id}>{invoice.agency_invoice.code}</Link>}
          </td>
          <td>
            <Link to={"#"}>{invoice.user.email}</Link>
            <br/>
            {invoice.user.agency && !invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Đại lý:</strong> {invoice.user.agency.agency_admin.email}</small>}
            {invoice.user.agency && invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Thương hiệu riêng:</strong> {invoice.user.agency.agency_admin.email}</small>}
            {!invoice.user.agency && <small className="text-muted"> <strong>Khách lẻ</strong> </small>}
          </td>	
          <td>
            {invoice.sale ? invoice.sale.email : "N/A"}
            <br/>
            <small>{invoice.sale && invoice.sale.full_name}</small>
          </td>	
          <td>
            {invoice.payment_type}
          </td>
          <td>
            {invoice.created_date}
          </td>
          <td>
            {InvoiceStatus(invoice.invoice_status)}
          </td>
          <td>
            {invoice.payment_date}
          </td>
          <td>
            {numeral(invoice.total).format('0,0')}
          </td>
          <td>
            <div className="icons-list">
              <div className="dropdown">
                <a href="#" className="list-icons-item" data-toggle="dropdown">
                  <i className="icon-menu9"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link to={role_path + "/invoice/detail/"+invoice.id} className="dropdown-item">
                    <i className="icon-list-numbered"></i> Chi tiết
                  </Link>
                </div>
              </div>
            </div>
          </td>
        </tr>
      )
    })
  return inner_invoice_rows;
}

class InvoiceDebtTable extends React.Component {
  constructor(props) {
    super(props);
    const {invoiceStatus, paymentMethod} = this.props.routeProps.match.params;
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        payment_type: paymentMethod,
        sort_by: "",
        sort_asc: false,
        search_field: "search",
        search_value: "",
        alert_label: null,
        from_date: moment(start_date_of_current_month).format("YYYY-MM-DD 00:00:00"),
        to_date: moment(end_date_of_current_month).format("YYYY-MM-DD 23:59:59")
      },
      invoice_static: null
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  listReload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice_debt/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  onPaymentTypeSelect = (payment_type) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      payment_type: payment_type
    };
    // listReload after setState
    this.listReload(table_query);
    history.push(role_path + "/invoice_debt/" + payment_type)
  }

  onDateChange = (from_date, to_date) => {
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: moment(from_date).format("YYYY-MM-DD 00:00:00"),
      to_date: moment(to_date).format("YYYY-MM-DD 23:59:59")
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });

    if(from_date && to_date) {
      this.listReload(table_query);
    }
  }

  render() {
    const { handleSubmit, userProfile, role_path } = this.props;
    const {table_query, table_data, alert_label} = this.state;
   

    return(
      <React.Fragment> 
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Công Nợ</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              {StringUtils.isEmptyOrSpaces(table_query.search_value) && <div className="row">
                <div className="col-md-12">
                  {InvoiceDatePicker(table_query.from_date, table_query.to_date, this.onDateChange, this.clearDataFilter)}
                  <center>
                    <div style={{float: "right" ,marginRight:10 }}>
                      <button onClick={() => this.onDateChange(start_date_of_previous_month, end_date_of_previous_month)} className="badge badge-secondary" style={{marginRight: 10 }}> Tháng Trước </button>
                      <button onClick={() => this.onDateChange(start_date_of_current_month, end_date_of_current_month)} className="badge badge-success"> Tháng Hiện Tại </button>
                    </div>
                  </center>
                </div>
              </div>}
              <div>
                <h5 style={{float: "right"}}>
                  Tổng: {table_data.data ? numeral(table_data.data.total_amount).format("0,0") : 0}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {alert_label && <AlertLabel status = {alert_label.status} message = {alert_label.message}/>}
            <div className="card">
              <div style={{margin:10}} className="text-align-right">
                <PaymentTypeSelect payment_type_selected={table_query.payment_type} onPaymentTypeSelect={this.onPaymentTypeSelect}/>
              </div>
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>Mã Đơn Hàng</th>
                      <th>Khách Hàng</th>
                      <th>Sale man</th>
                      <th>Phương Thức TT</th>
                      <th>Ngày Đăng Ký</th>
                      <th style={{width: "130px"}}>Trạng Thái</th>
                      <th>Ngày Thanh Toán</th>
                      <th>Tổng Tiền</th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && InvoiceRows(userProfile, role_path, table_data.data.invoice_list)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

const InvoiceDebtTableWrapper = reduxForm({
  form: 'InvoiceDebtTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(InvoiceDebtTable);

export default connect(mapState, mapDispatch)(withRouter(InvoiceDebtTableWrapper));